import { useMemo } from 'react';

import { MainText } from '@/components/Typography/NamedTypo';
import useAgentStore from '@/features/Agent/stores';

const useAgentSelect = () => {
  const agentMap = useAgentStore((state) => state.agentMap);

  const options = useMemo(() => {
    return [
      ...Object.values(agentMap).map((agent) => ({
        value: agent.alias,
        label: (
          <MainText>
            {agent.name}
            {'  '}
            <MainText dim>{agent.email}</MainText>
          </MainText>
        ),
        searchValue: `${agent.name} ${agent.email}`,
      })),
    ];
  }, [agentMap]);

  return options;
};

export default useAgentSelect;
